import React from 'react';

const RoomBlockUrl = 'http://bookings.ihotelier.com/bookings.jsp?groupID=2240587&hotelID=15014';
const WeddingEventSection = () => (
  <div>
    <section id="wedding-event" className="bg-img-cover bg-overlay-black-5 py-big">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-7 mb-md-5 text-center">
            <h3 className="font-alt letter-spacing-1 m-0 text-white text-uppercase title-small">The Wedding Event</h3>
            <span className="d-block font-alt2 mt-1 text-gray-100 text-large">If you have only one smile in you give it to the people you love.</span>
            <span className="bg-base-color d-block mt-3 mx-auto sep-line-thick-long" />
          </div>

        </div>


        <div className="row justify-content-center">
          <div className="col-md-9 col-lg-6 col-xl-5">
            <div className="bg-white h-100 p-5 rounded">
              <div className="p-xl-2">
                <h3 className="font-alt letter-spacing-1 text-extra-large text-uppercase">The Ceremony</h3>
                <span className="bg-base-color d-block mt-3 sep-line-thick" />
                <p className="mt-3 text-medium">Pavilion is located next to Kuilima Point at Turtle Bay Resort</p>

                <div className="d-flex flex-column">
                  <div className="align-items-center d-flex">
                    <i className="flaticon flaticon-014-date icon-small mr-4 text-base-color" />
                    <span className="text-gray-800 text-medium">
                                            Thursday - June 27, 2019
                      <br />
                                            03:30pm - 5:00pm
                    </span>
                  </div>


                  <div className="align-items-center d-flex">
                    <i className="flaticon flaticon-031-church icon-small mr-4 text-base-color" />
                    <span className="text-gray-800 text-medium">
                                            Pavilion
                      <br />
                                            Turtle Bay, Kahuku, HI
                    </span>
                  </div>

                </div>


                <div className="align-items-center d-flex mt-4">
                  <button type="button" onClick={() => window.location = RoomBlockUrl} className="btn btn-outline-black btn-small border-thick">Book a Room</button>
                  {/* <button type="button" data-toggle="modal" data-target="#modalWeddingEvent" className="btn btn-outline-black btn-small border-thick">How To Get There</button> */}
                  <a href="#rsvp" className="page-scroll btn btn-medium d-none d-sm-block text-base-color text-underline">RSVP Now</a>
                </div>

              </div>

            </div>

          </div>


          <div className="col-md-9 col-lg-6 col-xl-5 ml-xl-3 mt-5 mt-lg-0">
            <div className="bg-white h-100 p-5 rounded">
              <div className="p-xl-2">
                <h3 className="font-alt letter-spacing-1 text-extra-large text-uppercase">The Reception</h3>
                <span className="bg-base-color d-block mt-3 sep-line-thick" />
                <p className="mt-3 text-medium">Kuilima Point is the rocky outcropping located in front of the Turtle Bay Resort</p>

                <div className="d-flex flex-column">
                  <div className="align-items-center d-flex">
                    <i className="flaticon flaticon-014-date icon-small mr-3 text-base-color" />
                    <span className="text-gray-800 text-medium">
                                            Thursday - June 27, 2019
                      <br />
                                            06:00pm - 10:00pm
                    </span>
                  </div>


                  <div className="align-items-center d-flex">
                    <i className="flaticon flaticon-015-location icon-small mr-3 text-base-color" />
                    <span className="text-gray-800 text-medium">
                                            Kuilima Point
                      <br />
                                            Turtle Bay, Kahuku, HI
                    </span>
                  </div>

                </div>


                <div className="align-items-center d-flex mt-4">
                  <button type="button" onClick={() => window.location = RoomBlockUrl} className="btn btn-outline-black btn-small border-thick">Book a Room</button>
                  {/* <button type="button" data-toggle="modal" data-target="#modalWeddingEvent" className="btn btn-outline-black btn-small border-thick">How To Get There</button> */}
                  <a href="#rsvp" className="page-scroll btn btn-medium d-none d-sm-block text-base-color text-underline">RSVP Now</a>
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    </section>

    <div className="modal fade" id="modalWeddingEvent" tabIndex="-1" role="dialog" aria-labelledby="modalWeddingEvent" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 text-center">
                  <h3 className="modal-title font-alt letter-spacing-1 mt-1 text-large text-uppercase">How To Get To The Events</h3>
                </div>

              </div>

            </div>


            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>


          <div className="modal-body py-4">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6">
                  <div className="text-center">
                    <h4 className="font-alt2 mb-0 text-base-color title-small">The Ceremony</h4>
                    <span className="d-block text-medium">(St. Patrick's Church)</span>
                    <img src="./img/portfolio-2.jpg" alt="" className="img-fluid mt-3 rounded" />
                  </div>


                  <div className="pr-lg-3">
                    <span className="d-block font-alt letter-spacing-1 mt-4 text-small text-uppercase">By Car</span>
                    <span className="bg-base-color d-block mt-1 sep-line" />
                    <p className="mt-2 text-medium">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                  </div>


                  <div className="pr-lg-3">
                    <span className="d-block font-alt letter-spacing-1 mt-4 text-small text-uppercase">By Train</span>
                    <span className="bg-base-color d-block mt-1 sep-line" />
                    <p className="mt-2 text-medium">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                  </div>

                </div>


                <div className="col-lg-6 mt-5 mt-lg-0">
                  <div className="text-center">
                    <h4 className="font-alt2 mb-0 text-base-color title-small">The Reception</h4>
                    <span className="d-block text-medium">(The Mayflower Hotel)</span>
                    <img src="./img/portfolio-2.jpg" alt="" className="img-fluid mt-3 rounded" />
                  </div>


                  <div className="pr-lg-3">
                    <span className="d-block font-alt letter-spacing-1 mt-4 text-small text-uppercase">By Car</span>
                    <span className="bg-base-color d-block mt-1 sep-line" />
                    <p className="mt-2 text-medium">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                  </div>


                  <div className="pr-lg-3">
                    <span className="d-block font-alt letter-spacing-1 mt-4 text-small text-uppercase">By Train</span>
                    <span className="bg-base-color d-block mt-1 sep-line" />
                    <p className="mt-2 text-medium">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
);
export default WeddingEventSection;
